import type { FieldMergeFunction } from "@apollo/client/cache";
import type { StrictTypedTypePolicies } from "graphql-api/apollo-helpers";

const replaceIncoming: FieldMergeFunction = (_existing, incoming) => incoming;

export const typePolicies: StrictTypedTypePolicies = {
  MadeDesignProject: {
    keyFields: ["id"],
    fields: {
      products: {
        merge: replaceIncoming
      },
      backPlacement: {
        merge: replaceIncoming
      },
      frontPlacement: {
        merge: replaceIncoming
      }
    }
  },
  DtfArtwork: {
    keyFields: ["id"]
  },
  MadeDesignProjectProduct: {
    keyFields: ["catalogNumber", "compositionId"]
  },
  MadeDesignProjectProductVariantQuantity: {
    keyFields: ["variantId"]
  },
  MadeDesignProjectPlacement: {
    keyFields: ["id"],
    fields: {
      dtfArtwork: {
        merge: replaceIncoming
      }
    }
  },
  Order: {
    keyFields: ["id"]
  },
  Query: {
    fields: {
      currentOrder: {
        merge: replaceIncoming
      },
      madeDesignProject: {
        merge: replaceIncoming
      }
    }
  }
};
